import React from 'react';

interface IProps {
  pixelId: string | number;
  track?: string;
}

/* eslint-disable react/no-danger, jsx-a11y/alt-text */
const FacebookPixel: React.FC<React.PropsWithChildren<IProps>> = ({ pixelId, track = 'PageView' }) => (
  <script
    dangerouslySetInnerHTML={{
      __html: `
        !function(f,b,e,v,n,t,s)
        {if(f.fbq1)return;n=f.fbq1=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq1)f._fbq1=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window, document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
        fbq1('init', ${pixelId});
        fbq1('track', ${track});
        `,
    }}
  />
);

export default FacebookPixel;
